if (navigator.serviceWorker) {
  navigator.serviceWorker.register("/service-worker.js").then(function (reg) {
    // console.log("serive worker installed!");
    navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
      serviceWorkerRegistration.pushManager
        .subscribe({
          userVisibleOnly: true,
          applicationServerKey: window.vapidPublicKey,
        })
        .then(async function (sub) {
          const data = await fetch("/webpush_subscriptions", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(sub),
          }).then((r) => r.json());
          console.log(data);
        });
    });
  });
}
// Otherwise, no push notifications :(
else {
  console.error("Service worker is not supported in this browser");
}
